// Clicking a toast normally just dismisses it (the Dashboard's Toaster does that
// for every toast, anywhere on the bar). A toast that should take the officer
// somewhere instead registers an action here under its id; the Toaster runs it
// on a click anywhere on the bar and leaves the toast up. This is how the
// "filling the form..." toast becomes a link to the forms page without needing a
// tiny button the officer might miss.
const actions = new Map<string, () => void>();

export const setToastAction = (id: string, action: () => void) => void actions.set(id, action);
export const clearToastAction = (id: string) => void actions.delete(id);
export const hasToastAction = (id: string) => actions.has(id);

// True if the toast had an action (it was run); false means "dismiss it as usual".
export function runToastAction(id: string): boolean {
  const action = actions.get(id);
  if (!action) return false;
  action();
  return true;
}
